import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSVGContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 14px;
  ${props => (props.onClick !== undefined ? `cursor: pointer` : null)};
  ${props => (props.$color ? `color: ${props.$color}` : null)};
  ${props => (props.$fontSize ? `font-size: ${props.$fontSize}px` : null)};
  @media (max-width) {
    ${props =>
      props.$mobileFontSize ? `font-size: ${props.$mobileFontSize}px` : null};
  }
`;

const SvgIconContainer = ({
  color,
  fontSize,
  mobileFontSize,
  className = '',
  onClick,
  children,
}) => (
  <StyledSVGContainer
    $color={color}
    $fontSize={fontSize}
    $mobileFontSize={mobileFontSize}
    className={`${className} mr-svg-icon-con`}
    onClick={onClick}
  >
    {children}
  </StyledSVGContainer>
);

SvgIconContainer.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default SvgIconContainer;
